import React, {useState} from "react";
import { useDispatch } from "react-redux";
import { Row, Col, message } from "antd";
import { useIsMobile } from "../../../../Hooks";
import { error_message } from "../../../../Constant";
import { BOOK_TELE_APPOINTMENT, HUMS_ACKNOWLEDGEMENT } from "../../../../Services/endpoints";
import { postApi } from "../../../../Services/apiService";
import BookTeleMedical from "../BookTeleMedicalTemplate";
import BookedVisitsTemplate from "../BookedVisitsTemplate";
import { setAppointmentDetails } from "../../../../Redux/TeleAppointmentDetails/action";
import RaisedModal from "../AppointmentModal/raisedModal";
import { decrypt, encrypt } from "../../../../Services/AESEncryptionDecryption";
import "./style.css";
import { PolicyDetails } from "../../CommonData";

const TeleDetails = ({ bookedAppointment, proposerFirstName }) => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const {
    applicationID,
    appSource,
  } = PolicyDetails();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  
  const humsApiCall = async () => {
    if(appSource !== "APPTRACKER"){
      const payload = {
        ApplicationNo: applicationID,
      }
      const encryptedText = encrypt(JSON?.stringify(payload));
      try {
        const result = await postApi(HUMS_ACKNOWLEDGEMENT, {
          encodedString: encryptedText,
        });
        if(result?.data?.errorMessage){
          message.error(result?.data?.errorMessage);
        }
      } catch (error) {
        message.error(error_message?.common_error);
       }
    }
  }

  const bookAppointment = async (requestBody) => {
    try {
      const encodedRequest = encrypt(JSON?.stringify(requestBody))
      const result = await postApi(BOOK_TELE_APPOINTMENT, {
        encodedString: encodedRequest
      });
      if(result?.data?.response){
        const decryptedResponse = JSON?.parse(decrypt(result?.data?.response))
        if(decryptedResponse?.responseList){
          toggleModal();
          humsApiCall();
          dispatch(setAppointmentDetails({
            Application_Number: requestBody?.Application_Number,
            Insured_Info: requestBody?.Insured_Info,
          }));
        }
      }
      else{
        message.error(result?.errorMessage);
      }
    } catch (error) {
      message.error(error_message?.common_error);
     }
  };

  const CustomCardWrapper = (props) => {
    const { children } = props;
    return <div className={isMobile ? "" : "card"}>{children}</div>;
  };

  return (
    <section>
      <Row justify="space-between" gutter={[32, { xs: 32 }]}>
        <Col lg={24} md={24} className="member-details">
          <CustomCardWrapper>
            <Row gutter={[38, 24]}>
              <Col xs={24} sm={20} md={18} lg={15} className="l-col">
                {bookedAppointment?.length ? (
                  <BookedVisitsTemplate
                    bookedAppointment={bookedAppointment}
                  />
                ) : (
                  <BookTeleMedical
                    bookAppointment={bookAppointment}
                  />
                )}
              </Col>
            </Row>
          </CustomCardWrapper>
        </Col>
      </Row>
      <RaisedModal
        open={isModalOpen}
        onClose={toggleModal}
        proposerFirstName={proposerFirstName}
      />
    </section>
  );
};

export default TeleDetails;
